var site = site || {};
site.Video = (() => {
    // Functions
    const toggleVideo = () => {
        // Init empty array of iframe IDs, one from each video
        var iframeIds = [];
        // For each iframe you find, add its ID to the iframeIds array
        const iframes = document.querySelectorAll('.js-video-item iframe');
        iframes.forEach((iframe) => {
            iframeIds.push(iframe.id);
        });

        if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    
            window.onYouTubeIframeAPIReady = () => {
                onYouTubePlayer();
            };
        } else {
            onYouTubePlayer();
        }

        const onYouTubePlayer = () => {
            iframeIds.forEach((iframeId) => {
                new YT.Player(iframeId, {
                    events: {
                        onReady: onPlayerReady,
                        onStateChange: onPlayerStateChange,
                    },
                });
            });
        }

        const onPlayerReady = (event) => {
            const iframeObject = event.target;
            const iframeContainer = iframeObject.g.closest('.js-video-item');
            const iframeTrigger = iframeContainer.querySelector('.js-video-trigger');
            const iframeKeyboardTrigger = iframeContainer.querySelector('.js-video-trigger');

            iframeTrigger.addEventListener('click', () => {
                iframeTrigger.nextElementSibling.classList.add('z-2');
                iframeObject.playVideo();
            })

            iframeKeyboardTrigger.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    iframeTrigger.nextElementSibling.classList.add('z-2');
                    iframeObject.playVideo();
                }
            })
        }

        const onPlayerStateChange = (event) => {
            const iframeObject = event.target;
            const iframeContainer = iframeObject.g.closest('.js-video-item');
            const iframeTrigger = iframeContainer.querySelector('.js-video-trigger');

            if(event.data == 2) {
                iframeTrigger.nextElementSibling.classList.remove('z-2');
            }
        }
    }

    return {
        toggleVideo : toggleVideo
    };
})();